import { Card, Divider, SimpleGrid, Skeleton, Stack } from '@mantine/core';
import { TenantCardHeader } from './TenantCardHeader';

type TenantCardPlaceholderProps = {
  companyName: string;
};

export const TenantCardPlaceholder = ({ companyName }: TenantCardPlaceholderProps) => (
  <Card component="li" aria-label={companyName} aria-busy withBorder radius="lg" padding="lg">
    <TenantCardHeader companyName={companyName} />

    <SimpleGrid cols={2} spacing="sm">
      <Skeleton height={38} radius="sm" />
      <Skeleton height={38} radius="sm" />
    </SimpleGrid>

    <Divider my="md" color="gray.1" />

    <Stack gap={9}>
      <Skeleton height={12} radius="xl" />
      <Skeleton height={12} radius="xl" w="80%" />
      <Skeleton height={12} radius="xl" w="60%" />
    </Stack>
  </Card>
);
